/**
 * **Ensana Hotels**
 *
 * @exports partnership_10026
 * @category partnerships
 */
function factory({ window, document, thn }) {
    const partnership = {};
    /**
      * @memberOf module:partnership_10026
      */
    partnership.boot = function boot() {
        if (!window.dataLayer) {
            return;
        }
        partnership.shutdown = thn.generateCallbackQueue();
        const refreshPartnership = thn.debounce(thn.siteCheck, 300);
        let dataLayerHelper = new thn.DataLayerHelper(window.dataLayer, function (model, message) {
            if (message.event === 'gtm.historyChange-v2' || message[1] === 'page_view') {
                refreshPartnership();
            }
        }, true);
        partnership.shutdown = function () {
            dataLayerHelper.unlisten();
            dataLayerHelper = null;
        };
    };
    /**
      * @memberOf module:partnership_10026
      */
    partnership.getId = function getId() {
        return '10026';
    };
    /**
      * @memberOf module:partnership_10026
      */
    partnership.check = function check() {
        // Check if we are in the website of Ensana Hotels
        return !!window.location.hostname.includes('ensanahotels') && !window.location.hostname.includes('booking');
    };
    /**
      * @memberOf module:partnership_10026
      */
    partnership.getHotelId = function getHotelId() {
        const hotelId = window.location.pathname.split('/')[3];
        const isCorpo = !window.location.pathname.match(/hotels|szallodak|oteli|hotely|hoteluri/);
        let result;
        if (!isCorpo) {
            result = {
                partnership_hotel_id: hotelId,
            };
        }
        else {
            result = {
                account_key: '0C17D0DB2A1499BFC93E05002ADA0687',
            };
        }
        return result;
    };
    return partnership;
}

export { factory };
